module.exports = __webpack_public_path__ + "img/image169.7f024dcd.jpg";